import React, { useContext, useEffect, useState } from 'react';

import { TaskEntity } from '../../tasks/Task.interface';
import {
  useCreateProductUserNeed,
  useProductEntityPrefixId,
  useProductViewParams,
  useUpdateProductUserNeed
} from '../Product.hooks';
import {
  BaseProductBoardColumnProps,
  ProductUserNeed
} from '../Product.interface';
import { ProductBoardContext } from './ProductBoard.context';
import { ProductBoardColumnEntity } from './ProductBoardColumn';
import ProductBoardItem from './ProductBoardItem';

export type ProductBoardUserNeedProps = BaseProductBoardColumnProps<
  ProductUserNeed,
  'userNeed'
>;

const ProductBoardUserNeed: React.FC<ProductBoardUserNeedProps> = (
  props: ProductBoardUserNeedProps
) => {
  const {
    product,
    collapsed,
    userNeed: initialUserNeed,
    onCancel,
    onError,
    onSave
  } = props;
  const entity = ProductBoardColumnEntity.UserNeed;
  const params: string = useProductViewParams();
  const { toggleSelected, isSelected } = useContext(ProductBoardContext);
  const [userNeed, setUserNeed] = useState(initialUserNeed);
  useEffect(() => {
    if (initialUserNeed) {
      setUserNeed(initialUserNeed);
    }
  }, [initialUserNeed]);
  const {
    createdProductUserNeed,
    isCreatingProductUserNeed,
    createProductUserNeedError,
    createProductUserNeed
  } = useCreateProductUserNeed(product.id);
  const {
    updatedProductUserNeed,
    isUpdatingProductUserNeed,
    updateProductUserNeed
  } = useUpdateProductUserNeed(product.id, userNeed.id || 0);
  const entityId: string = useProductEntityPrefixId(
    userNeed,
    ProductBoardColumnEntity.UserNeed
  );

  useEffect(() => {
    if (createdProductUserNeed) {
      setUserNeed(createdProductUserNeed);
      onSave?.(createdProductUserNeed, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdProductUserNeed]);

  useEffect(() => {
    if (updatedProductUserNeed) {
      setUserNeed(updatedProductUserNeed);
      onSave?.(updatedProductUserNeed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductUserNeed]);

  useEffect(() => {
    if (createProductUserNeedError) {
      onError?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProductUserNeedError]);

  return (
    <ProductBoardItem
      product={product}
      taskEntity={userNeed as TaskEntity}
      title={userNeed.title || ''}
      entityId={entityId}
      collapsed={collapsed}
      editable={!userNeed.id}
      isSelected={isSelected(userNeed.id, entity)}
      loading={isUpdatingProductUserNeed || isCreatingProductUserNeed}
      viewDetailsLink={`/portal/products/${userNeed.productId}/user-needs/${userNeed.id}${params}`}
      onSelect={() => toggleSelected(userNeed, entity)}
      onCancel={() => {
        setUserNeed(initialUserNeed);
        onCancel?.();
      }}
      onSave={title => {
        userNeed.title = title;
        if (userNeed.id) {
          updateProductUserNeed(userNeed);
        } else {
          createProductUserNeed(userNeed);
        }
      }}
    />
  );
};

export default ProductBoardUserNeed;
